import { RECEIVE_RECENT_TICKETS_FAILURE, RECEIVE_RECENT_TICKETS_SUCCESS, REQUEST_RECENT_TICKETS_ACTION } from '../actions/recentTicketActions'

export const initialState = {
  isFetching: false,
  errors: [],
  tickets: [],
  refreshNeeded: false,
  pagination: {},
  statusCount: {},
  numFlagged: 0
}

export default function recentTicketsReducer (reduxState = initialState, action) {
  const { type, payload } = action
  const statusCount = {
    open: 0,
    en_route: 0,
    completed: 0,
    cancelled: 0,
    invoiced: 0
  }
  let numFlagged = 0
  switch (type) {
    case REQUEST_RECENT_TICKETS_ACTION:
      return {
        ...reduxState,
        isFetching: true,
        errors: []
      }
    case RECEIVE_RECENT_TICKETS_FAILURE:
      return {
        ...reduxState,
        isFetching: false,
        errors: payload.errors
      }
    case RECEIVE_RECENT_TICKETS_SUCCESS:
      payload.nodes.map((ticket) => {
        ++statusCount[ticket.status]
        if (ticket.flagged) {
          ++numFlagged
        }
        return numFlagged
      })

      return {
        ...reduxState,
        isFetching: false,
        refreshNeeded: false,
        tickets: payload.nodes,
        totalCount: payload.totalCount,
        statusCount,
        numFlagged
      }
    default:
      return reduxState
  }
}
